import React, {useEffect, useState} from 'react'

import {Alert, AlertTitle, Snackbar, Switch} from '@mui/material'
import {api} from '../common/api'
import {useSelector} from 'react-redux'
import {selectedSiteSelector} from '../authentication/redux'
import {useTranslation} from 'react-i18next'
import axios from 'axios'

type Props = {
    userBusinessId: string
    available: boolean
    answerGroupId: string
    queue: boolean
    readonly ?: boolean
}

export const AgentAvailabilitySwitch = ({ answerGroupId, userBusinessId, available, queue, readonly }: Props) => {
    const [checked, setChecked] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)
    const [success, setSuccess] = useState<boolean>(false)
    const { t } = useTranslation()

    const site = useSelector(selectedSiteSelector)

    useEffect(() => {
        setChecked(available)
    }, [available])

    const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked)
        if (site) {
            try {
                await api.put(`/api/site/${site.productId}/answergroup/${answerGroupId}/toggle-agent-availability`, {
                    available: event.target.checked,
                    userBusinessId: userBusinessId,
                })
                setSuccess(true)
            } catch (err) {
                setChecked(!event.target.checked)
                setSuccess(false)
                if (axios.isAxiosError(err)) {
                    const data = err?.response?.data as [any]
                    if (err.response?.status === 400 && !!data) {
                        data.forEach(serverError => setError(`general.form-error.${serverError.key}`))
                    } else {
                        setError('general.unknown-server-error')
                    }
                } else {
                    setError('general.unknown-server-error')
                }
                return
            }
        }
    }

    return (
        <>
            {queue ? <Switch size="small" onChange={handleChange} checked={checked} disabled={readonly} /> : <></>}
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={!!error} autoHideDuration={5000} onClose={() => setError(null)}>
                <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
                    <AlertTitle>{t('general.error')}</AlertTitle>
                    {error && t(error)}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={success} autoHideDuration={3000} onClose={() => setSuccess(false)}>
                <Alert onClose={() => setSuccess(false)} severity="success" sx={{ width: '100%' }}>
                    <AlertTitle>{t('general.succeeded')}</AlertTitle>
                    {t(checked ? 'flows.detail.agent-availability-switch-on-success' : 'flows.detail.agent-availability-switch-off-success')}
                </Alert>
            </Snackbar>
        </>
    )
}
